import { render, staticRenderFns } from "./WeekDays.vue?vue&type=template&id=6f5fe06a&scoped=true"
import script from "./WeekDays.vue?vue&type=script&lang=js"
export * from "./WeekDays.vue?vue&type=script&lang=js"
import style0 from "./WeekDays.vue?vue&type=style&index=0&id=6f5fe06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5fe06a",
  null
  
)

export default component.exports